import React, { useState } from 'react';
import {
  Button,
  SnapDialog,
  TextField,
  SecuredTextField
} from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './AwarenessPageStyles.css';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function BankInfoPage({
  isVisible,
  onClose,
  totalAmount,
  goBack,
  onContinue,
  isSubmitLoading
}) {
  const [routingNumber, setRoutingNumber] = useState('021000021');
  const [accountNumber, setAccountNumber] = useState('7657657657');

  const isContinueButtonDisabled = () => !routingNumber || !accountNumber;

  return (
    <SnapDialog
      open={isVisible}
      onClose={onClose}
      className="custom-dialog-sm-width"
    >
      <div className="verification-page-div">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="lto-mob-vcode-1">Add an active checking account</div>
          <div className="bank-route-info">
            We&apos;ll use this information to verify your identity. We&apos;ll
            debit this account for your regular payments.
          </div>
          <div className="find-routing-txt">
            Find my routing and account numbers
            <img
              src="/info-icon-small.svg"
              alt="Info Icon"
              width={13}
              className="routing-info-icon"
            />
          </div>
          <div className="personal-info-form">
            <div className="email-section">
              <TextField
                label="Bank Routing Number"
                value={routingNumber}
                onChange={(e) => setRoutingNumber(e.target.value)}
                style={{ width: '100%' }}
              />
            </div>
            <br />
            <div className="identity-verification-section">
              <SecuredTextField
                label="Checking Account Number"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                definitionMask="*"
                style={{ width: '100%' }}
                maskedValue={false}
                mask="XXXXXXXXX"
              />
            </div>
          </div>
          <br />
          <Button
            className="continue-button"
            onClick={onContinue}
            disabled={isContinueButtonDisabled()}
            loading={isSubmitLoading}
          >
            Continue
          </Button>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

BankInfoPage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired,
  isSubmitLoading: PropTypes.bool.isRequired
};

export default BankInfoPage;
